<div class="ddp">
    <header class="ddp__header">
        <button class="kbma-btn kbma-btn--ghost" (click)="back()">✕ Close</button>
        <div class="title-block">
            <h2>{{ title }}</h2>
            <p class="sub">
                <span class="numeric">{{ startDate | date:'MM/dd/yyyy' }}</span>
                <span class="numeric">&nbsp;→&nbsp;{{ endDate | date:'MM/dd/yyyy' }}</span>
                <span> · Location #<span class="numeric">{{ locationId }}</span></span>
                <span> · <span class="numeric">{{ rows.length }}</span> row(s)</span>
            </p>
        </div>
    </header>

    <!-- All branches are rendered conditionally but ONLY ONE will ever evaluate
         true on this page's initial mount, since constructor-set fields don't
         change. No post-mount transitions = no CD breakage to worry about. -->
    <div *ngIf="missingState" class="ddp__empty">
        No drill-down data. Please return to the dashboard and click a tile.
    </div>
    <div *ngIf="!missingState && error" class="ddp__error">
        <strong>Error:</strong> {{ error }}
    </div>
    <div *ngIf="!missingState && !error && rows.length === 0" class="ddp__empty">
        No records.
    </div>
    <div *ngIf="!missingState && !error && rows.length > 0" class="ddp__body">
        <table class="kbma-table">
            <thead>
                <tr>
                    <th *ngFor="let c of columns()" [ngClass]="(c.type === 'num' || c.type === 'money') ? 'numeric' : ''">{{ c.header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let r of rows">
                    <!-- resStatus cells get the same background colour as the
                         canonical /reservations list (see resStatusColor() /
                         ConstantService.reservationStatuses). null binding for
                         non-resStatus columns leaves the cell unstyled. -->
                    <td *ngFor="let c of columns()"
                        [ngClass]="(c.type === 'num' || c.type === 'money') ? 'numeric' : ''"
                        [style.background-color]="c.type === 'resStatus' ? resStatusColor(r[c.field]) : null">
                        <ng-container [ngSwitch]="c.type">
                            <!-- Value IS the STR id (e.g. "STR ID" column for unit drill-downs). -->
                            <a *ngSwitchCase="'propertyLink'"
                               class="ddp-link"
                               [href]="propertyEditUrl(r[c.field])"
                               target="_blank" rel="noopener noreferrer">{{ format(r, c) }}</a>
                            <!-- Displays propertyCode but links via row[linkField] (= shortTermRentalId). -->
                            <a *ngSwitchCase="'propertyCodeLink'"
                               class="ddp-link"
                               [href]="propertyEditUrl(r[c.linkField || ''])"
                               target="_blank" rel="noopener noreferrer">{{ format(r, c) }}</a>
                            <!-- Value IS the orderId; links to /order/{value}. -->
                            <a *ngSwitchCase="'orderLink'"
                               class="ddp-link"
                               [href]="orderUrl(r[c.field])"
                               target="_blank" rel="noopener noreferrer">{{ format(r, c) }}</a>
                            <!-- Displays reservationId but links to /order/{orderId}. -->
                            <a *ngSwitchCase="'reservationLink'"
                               class="ddp-link"
                               [href]="orderUrl(r[c.linkField || ''])"
                               target="_blank" rel="noopener noreferrer">{{ format(r, c) }}</a>
                            <!-- Displays the formatted room-status name (e.g. 'Occupied')
                                 AND links it to /order/{occupyingOrderId} — the order of the
                                 reservation that put this unit in that status. orderUrl()
                                 returns 'javascript:void(0)' when the order id is null, so
                                 the anchor stays safe to render either way. -->
                            <a *ngSwitchCase="'roomStatusLink'"
                               class="ddp-link"
                               [href]="orderUrl(r[c.linkField || ''])"
                               target="_blank" rel="noopener noreferrer">{{ format(r, c) }}</a>
                            <!-- Plain cell — default. -->
                            <span *ngSwitchDefault
                                  [ngClass]="(c.type === 'num' || c.type === 'money' || c.type === 'date') ? 'numeric' : ''">{{ format(r, c) }}</span>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
